import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, author, ogTitle, ogDescription, ogImage, ogUrl, canonical }) => {
    return (
        <Helmet>
            <title>{title ? `${title} | Apna Plaza` : 'Apna Plaza'}</title>
            <meta name="description" content={description || "A Digital Home for Gul Plaza Businesses!"} />
            <meta name="keywords" content={keywords || "shopping, ecommerce, buy, sell, apna plaza"} />
            <meta name="author" content={author || "Apna Plaza"} />
            
            {/* Canonical Link */}
            {canonical && <link rel="canonical" href={canonical} />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={ogTitle || title || "Apna Plaza"} />
            <meta property="og:description" content={ogDescription || description || "Apna Plaza - Your one-stop shop for everything!"} />
            <meta property="og:image" content={ogImage || "https://apnaplaza.store/logo192.png"} />
            <meta property="og:url" content={ogUrl || window.location.href} />
            <meta property="og:site_name" content="Apna Plaza" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={ogTitle || title || "Apna Plaza"} />
            <meta name="twitter:description" content={ogDescription || description || "Apna Plaza - Your one-stop shop for everything!"} />
            <meta name="twitter:image" content={ogImage || "https://apnaplaza.store/logo192.png"} />
        </Helmet>
    );
};

export default SEO;
